<div class="bigger-container">
  <div class="left-section">
    <p [ngClass]="{ selected: step === 0 }" (click)="changeTab(0)">
      Anagrafica
    </p>
    <p [ngClass]="{ selected: step === 1 }" (click)="changeTab(1)">
      Formazione
    </p>
  </div>
  <div class="right-section">
    <div class="back-button" (click)="goBack()">
      <i class="material-icons">arrow_back</i>
      <p>Torna alla lista</p>
    </div>
    <div class="smaller-container">
      <p class="smaller-text">{{ isNew ? "Crea" : "Dettagli" }} Coach</p>
      <div class="smaller-bar"></div>
    </div>
    <form [formGroup]="form" class="mt-5 px-3">
      <!-- -INFO -->
      <div *ngIf="step === 0" class="grid" formGroupName="info">
        <div>
          <label class="label" for="name">Nome<span class="red">*</span></label>
          <input readonly type="text" id="name" formControlName="name" />
        </div>
        <div>
          <label class="label" for="surname"
            >Cognome<span class="red">*</span></label
          >
          <input readonly type="text" id="surname" formControlName="surname" />
        </div>
        <div>
          <label class="label" for="email"
            >Email<span class="red">*</span></label
          >
          <input readonly type="text" id="email" formControlName="email" />
        </div>
        <div>
          <label class="label" for="phone"
            >Cellulare<span class="red">*</span></label
          >
          <input readonly type="text" id="phone" formControlName="phone" />
        </div>
        <div>
          <label class="label" for="age">Età<span class="red">*</span></label>
          <input
            readonly
            type="number"
            id="age"
            formControlName="age"
            min="0"
            max="99"
          />
        </div>

        <div></div>

        <div *ngIf="coach !== undefined">
          <!-- id -->
          <label class="label" for="subInterest">ID coach:</label>
          <p style="font-weight: bold">{{ coach.docRef }}</p>
        </div>
        <!-- calendar link -->
        <div>
          <label class="label" for="calendarLink">Link al calendario</label>
          <input
            readonly
            type="text"
            id="calendarLink"
            formControlName="calendarLink"
          />
        </div>
      </div>

      <!-- -SPECIALITIES -->
      <div
        *ngIf="step === 1"
        style="display: flex; flex-direction: column; margin-top: 20px"
      >
        <label
          style="text-align: start; width: 100%; margin-bottom: 10px"
          class="label"
          for="specialties"
          >Specializzazioni</label
        >

        <ul>
          <li *ngIf="form.get('life_coaching')?.value">Life coaching</li>
          <li *ngIf="form.get('coaching_aziendale')?.value">
            Coaching aziendale
          </li>
          <li *ngIf="form.get('executive_coaching')?.value">
            Executive coaching
          </li>
          <li *ngIf="form.get('coaching_di_leadership')?.value">
            Coaching di leadership
          </li>
          <li *ngIf="form.get('leadership_coaching')?.value">
            Leadership coaching
          </li>
          <li *ngIf="form.get('mindfulness_coaching')?.value">
            Mindfulness coaching
          </li>

          <li *ngIf="form.get('relationship_coaching')?.value">
            Coaching relazionale
          </li>
          <li *ngIf="form.get('spiritual_coaching')?.value">
            Coaching spirituale
          </li>
          <li *ngIf="form.get('coaching_for_personal_growth')?.value">
            Coaching per la crescita personale
          </li>
          <li *ngIf="form.get('corporate_wellness_coaching')?.value">
            Coaching per il benessere aziendale
          </li>
          <li
            *ngIf="
              form.get('mental_coaching_per_sportivi_e_performance')?.value
            "
          >
            Mental coaching per sportivi
          </li>
        </ul>
      </div>
    </form>
    <div class="save-container">
      <button
        class="my-button"
        [class.disabled]="form.invalid"
        [disabled]="form.invalid"
        id="save-button"
        (click)="save(true)"
      >
        Salva
      </button>
      <p *ngIf="form.invalid" class="save-hint red">
        Mancano: {{ getMissingFields().join(', ') }}
      </p>
    </div>
  </div>
</div>

<app-alert
  *ngIf="showAlert"
  (save)="onAlertAction($event)"
  [data]="{ type: undefined }"
  [title]="'Attenzione, alcuni dati sono stati modificati!'"
  [message]="'Vuoi salvare le modifiche effettuate?'"
>
</app-alert>

<div
  class="modal"
  id="modal-container"
  *ngIf="showModal"
  (click)="dismiss($event)"
>
  <div class="modal-content">
    <app-image-cropper
      [imageSource]="sanitize(chosenPhoto)"
      (outputEvent)="getCroppedPhoto($event)"
    >
    </app-image-cropper>
    <div class="modal-button-container">
      <button class="secondary-button" (click)="cropperAbort()">Annulla</button>
      <button
        class="secondary-button"
        (click)="uploadImage(finalPhoto, coach.docRef)"
      >
        Conferma
      </button>
    </div>
  </div>
</div>
